import { KeyedObject } from '../abelcommon';
import axios from 'axios';
import { useQuery, useQueryClient } from 'react-query';
import { environment } from '../config/environment';

export function fetchTxs(blockHeight: number, address: string, txType: string, start?: number, count?: number) {
  const searchParams = new URLSearchParams();
  if (blockHeight >= 0) {
    searchParams.append('height', String(blockHeight));
  }
  if (address && address.length > 0) {
    searchParams.append('address', address);
  }
  if (txType === 'coinbase' || txType === 'transfer') {
    searchParams.append('type', txType);
  }
  if (start !== undefined) {
    searchParams.append('start', String(start));
  }
  if (count !== undefined) {
    searchParams.append('count', String(count));
  }

  return axios.get(`${environment.apiBase}/tx/list?${searchParams.toString()}`).then((res) => res.data);
}

export function useTxs(
  blockHeight: number,
  address: string,
  txType: string,
  start?: number,
  count?: number,
  options?: KeyedObject
) {
  const queryClient = useQueryClient();
  return useQuery(['txs', blockHeight, address, txType, start, count], () => fetchTxs(blockHeight, address, txType, start, count), {
    retry: false,
    staleTime: 1000 * 60 * 5,
    refetchOnMount: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    onSuccess: (data) => {
      // Update tx
      data.payload && Object.keys(data.payload).forEach((i) => {
        const r = { type: 'txdetail', payload: data.payload[i] };
        queryClient.setQueryData(['txdetail', '0x' + data.payload[i].txid], r);
      });
    },
    ...options,
  });
}

export default useTxs;
